import React from 'react'
import { useAuthStore } from '../store/useAuthStore'

export default function Header({ title }) {
  const { authUser } = useAuthStore()
  return (
    <div id="header" className="flex items-center justify-between mb-8">
      <h1 className="text-3xl font-bold text-[#1e293b] tracking-tight">
        {title}
      </h1>
      <div className="flex items-center gap-4">
        <button className="relative">
          <i className="fa-regular fa-bell text-xl text-[#64748b]"></i>
          <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-4 h-4 bg-[#ef4444] text-[10px] text-white rounded-full font-bold">
            3
          </span>
        </button>
        {
          authUser && authUser?.avatar &&
          <img
            src={authUser?.avatar}
            className="w-10 h-10 rounded-full object-cover border-2 border-[#3b82f6]"
            alt="icon" />
        }

      </div>
    </div>
  )
}
